

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <div className="relative w-10 h-10 flex items-center justify-center mr-3">
                <div className="absolute inset-0 bg-gradient-to-br from-emerald-400 via-cyan-500 to-blue-600 rounded-xl rotate-12 transform"></div>
                <div className="absolute inset-0 bg-gradient-to-tr from-purple-500 via-pink-500 to-red-500 rounded-xl -rotate-12 transform opacity-80"></div>
                <div className="relative z-10 w-8 h-8 bg-white rounded-lg flex items-center justify-center shadow-lg">
                  <div className="w-3 h-3 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full"></div>
                  <div className="absolute top-1 right-1 w-1 h-1 bg-emerald-500 rounded-full"></div>
                  <div className="absolute bottom-1 left-1 w-1 h-1 bg-blue-500 rounded-full"></div>
                </div>
              </div>
              <span className="text-xl font-bold bg-gradient-to-r from-purple-400 via-pink-400 to-blue-400 bg-clip-text text-transparent tracking-wide" style={{fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif', fontWeight: '800', letterSpacing: '0.05em'}}>
                SoundWave
              </span>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              The ultimate music streaming platform where artists and listeners connect. 
              Discover, share, and enjoy music like never before.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-purple-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-purple-600 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-purple-600 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-purple-600 transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4">Platform</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Discover</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Browse</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Charts</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">New Releases</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Genres</a></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-semibold mb-4">Support</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Help Center</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Contact Us</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Community</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Artist Resources</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">API</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm mb-4 md:mb-0">
            © 2024 SoundWave. All rights reserved.
          </div>
          <div className="flex items-center space-x-6 text-gray-400 text-sm">
            <a href="#" className="hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors cursor-pointer">Terms of Service</a>
            <a href="#" className="hover:text-white transition-colors cursor-pointer">Cookies</a>
            <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer">Website Builder</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

